import { fmt } from "../lib/format";

export const OrdersPanel = ({ orders }) => {
  if (!orders?.length)
    return <div className="flex-1 flex items-center justify-center text-zinc-600 text-[11px]">No working orders</div>;
  return (
    <div className="flex-1 min-h-0 overflow-auto thin-scroll">
      <table className="w-full text-[11px]">
        <thead className="text-[9px] uppercase text-zinc-500 sticky top-0 bg-[#09090b]">
          <tr className="border-b border-zinc-800">
            <th className="text-left font-medium px-2 py-1">Sym</th>
            <th className="text-left font-medium px-1 py-1">Leg</th>
            <th className="text-left font-medium px-1 py-1">Type</th>
            <th className="text-left font-medium px-1 py-1">Side</th>
            <th className="text-right font-medium px-1 py-1">Qty</th>
            <th className="text-right font-medium px-1 py-1">Price</th>
            <th className="text-right font-medium px-2 py-1">Status</th>
          </tr>
        </thead>
        <tbody className="font-mono">
          {orders.map((o) => (
            <tr key={o.id} data-testid={`order-${o.id}`} className="border-b border-zinc-800/60 hover:bg-zinc-800/30">
              <td className="px-2 py-1 font-bold text-zinc-100">{o.symbol}</td>
              <td className={`px-1 py-1 ${o.leg === "TAKE PROFIT" ? "text-blue-400" : "text-red-400"}`}>{o.leg}</td>
              <td className="px-1 py-1 text-zinc-400">{o.type}</td>
              <td className={`px-1 py-1 ${o.side === "BUY" ? "text-green-500" : "text-red-500"}`}>{o.side}</td>
              <td className="px-1 py-1 text-right text-zinc-300">{o.qty}</td>
              <td className="px-1 py-1 text-right text-zinc-100">{fmt(o.price)}</td>
              <td className="px-2 py-1 text-right">
                <span className="px-1 py-[1px] text-[9px] rounded-sm bg-amber-500/10 text-amber-400 border border-amber-500/20">{o.status}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
